import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconBlockquote(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.349 4.819c-.111-.703.393-1.356 1.126-1.47.733-.099 1.526.277 1.711 1.25.2 1.406-.874 2.563-2.46 2.734-.059.007-.067-.028-.067-.028l-.074-.44s-.007-.043.037-.057c.459-.128.837-.348.993-.902-.622-.028-1.171-.469-1.267-1.086zm5.059 1.086c-.63-.021-1.17-.462-1.267-1.086-.119-.703.385-1.356 1.119-1.47.726-.099 1.526.277 1.719 1.25.185 1.406-.874 2.563-2.467 2.734-.059.007-.067-.028-.067-.028l-.067-.44s-.007-.043.037-.057c.452-.128.845-.348.993-.902zM14 6a.667.667 0 1 1 0 1.334h-4A.667.667 0 1 1 10 6h4zm0-2.667a.667.667 0 1 1 0 1.334h-4a.667.667 0 1 1 0-1.334h4zm0 5.334a.667.667 0 1 1 0 1.334H2a.667.667 0 1 1 0-1.334h12zm0 2.666a.667.667 0 1 1 0 1.334H2a.667.667 0 1 1 0-1.334h12z"
  }));
}
IconBlockquote.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconBlockquote.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconBlockquote as default };
